class MorphTargetController {
    setInfluences(object, influences) {
        throw new Error("Method .setInfluences is not implemented");
    }

    setInfluence(object, index, influence) {
        throw new Error("Method .setInfluence is not implemented");
    }

    clearInfluences(object) {
        throw new Error("Method .clearInfluences is not implemented");
    }
}

export default MorphTargetController;
